import * as React from 'react';
import {useIsClientOnlyRendering} from '../utils/useIsClientOnlyRendering';
import {useGlobalConfig, useLogger} from '../context';
import {PriorityPersonalizationLoader} from '../context/personalization/PriorityPersonalizationLoader';
import {Logger} from '../context/logger/Logger';

export interface InitializationProps {
    children?: React.ReactNode;
    finishedHydration?: () => void;
}

/**
 *
 * @param props this Component runs code right after hydration
 * @returns
 */
export const Initialization = (props: InitializationProps) => {
    const {finishedHydration} = props;
    const timeout = useGlobalConfig().personalizationConfig.timeout;
    const logger = useLogger();

    const clientOnly = useIsClientOnlyRendering();

    React.useEffect(() => {
        if (clientOnly) {
            logger.general.info('initialization after hydration');
            finishedHydration && finishedHydration();
            // need to load from singleton because it might be overwritten by mock.
            startTimeoutForPersonalization(logger, timeout);
        }
    }, [clientOnly, finishedHydration, logger, timeout]);
    return props.children;
};

function startTimeoutForPersonalization(logger: Logger, timeout: number) {
    const initialPathname = window.location.pathname;
    setTimeout(() => {
        // escape hatch to show default if something goes wrong with personalization
        if (window.location.pathname === initialPathname) {
            PriorityPersonalizationLoader.showDefault();
            logger.personalization.debug('removing flicker defender');
        }
    }, timeout);
}
